"use strict";
var StatusTagStyle = /* @__PURE__ */ ((StatusTagStyle2) => {
  StatusTagStyle2["Default"] = "default";
  StatusTagStyle2["Success"] = "success";
  StatusTagStyle2["Info"] = "info";
  StatusTagStyle2["Warning"] = "warning";
  StatusTagStyle2["Alert"] = "alert";
  return StatusTagStyle2;
})(StatusTagStyle || {});
var StatusTagSize = /* @__PURE__ */ ((StatusTagSize2) => {
  StatusTagSize2["Small"] = "small";
  StatusTagSize2["Medium"] = "medium";
  return StatusTagSize2;
})(StatusTagSize || {});
class StatusTag extends React.Component {
  render() {
    const styleClass = `v3__status-tag--color-${this.props.style || "default" /* Default */}`;
    const sizeClass = `v3__status-tag--size-${this.props.size || "medium" /* Medium */}`;
    const outlineClass = this.props.outlined && "v3__status-tag--outlined";
    const className = `v3__status-tag ${styleClass} ${sizeClass} ${outlineClass}`;
    return /* @__PURE__ */ React.createElement("span", { className, style: { boxSizing: "content-box" } }, this.props.content);
  }
}
;
export { StatusTag, StatusTagStyle, StatusTagSize };
